<template>

    <Head v-if="title" :title="title" />

    <div class="h-screen flex overflow-hidden bg-gray-100">
        <div class="d-none bg-green-100 bg-red-100 bg-white bg-yellow-100"></div> <!-- compile green -->

        <!-- TW Snippet Start v2.0+ -->
        <div v-if="isOnTrial" style="z-index: 1000;" class="fixed top-3 inset-x-0 pb-2 sm:pb-5 pointer-events-none">
            <div style="pointer-events: all;" class="max-w-3xl mx-auto px-2 sm:px-6 lg:px-8">
                <div class="rounded-lg bg-yellow-400 shadow-lg">
                    <div class="flex items-center justify-between flex-wrap">
                        <div class="w-0 flex-1 flex items-center">

                            <p class="ml-3 font-medium text-white truncate">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span>
                                  Vaše zkušební doba vyprší za {{ isOnTrial }} dní.
                                </span>

                            </p>
                        </div>
                        <div class="order-2 shrink-0 sm:order-3 sm:ml-2">
                            <button @click="isOnTrial = null" type="button" class="-mr-1 flex p-2 rounded-md focus:outline-none">
                                <span class="sr-only">Skrýt</span>
                                <!-- Heroicon name: outline/x -->
                                <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition
            enter-active-class="duration-300"
            enter-from-class="display-block"
            enter-to-class="display-none"
            leave-active-class="duration-300"
            leave-from-class="display-none"
            leave-to-class="display-block">
            <div v-show="showMainMenu" class="md:hidden">
                <div class="fixed inset-0 flex z-40">

                    <transition
                        enter-active-class="transition-opacity ease-linear duration-300"
                        enter-from-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="transition-opacity ease-linear duration-300"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
                        <div v-show="showMainMenu" class="fixed inset-0" aria-hidden="true">
                            <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
                        </div>
                    </transition>

                    <transition
                        enter-active-class="transition ease-in-out duration-300 transform"
                        enter-from-class="-translate-x-full"
                        enter-to-class="translate-x-0"
                        leave-active-class="transition ease-in-out duration-300 transform"
                        leave-from-class="translate-x-0"
                        leave-to-class="-translate-x-full">
                        <div v-show="showMainMenu" class="relative flex-1 flex flex-col max-w-xs w-full pt-3 pb-0 bg-white">
                            <div class="absolute top-0 right-0 -mr-12 pt-2">
                                <button
                                    @click="showMainMenu = false"
                                    class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <span class="sr-only">Close sidebar</span>
                                    <!-- Heroicon name: x -->
                                    <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <div class="shrink-0 flex items-center px-4 self-center">
                                <jet-nav-link class="no-underline" style="border-bottom: 0;" :href="route('app')">
                                    <LogoImg full class="h-10 w-auto" />
                                </jet-nav-link>
                            </div>

                            <div class="mt-2 flex-1 h-0 overflow-y-auto">
                                <nav class="px-2 space-y-1">

                                    <!-- User account dropdown -->
                                    <div class="mt-2 mb-4 relative inline-block text-left w-full">
                                        <!-- Dropdown menu toggle, controlling the show/hide state of dropdown menu. -->
                                        <div @click="handleSelectorClick" @focusout="boxDropdownShow = false">
                                            <button type="button" class="group w-full bg-gray-100 rounded-md px-3.5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" aria-haspopup="true" aria-expanded="true">
                                                <span class="flex w-full justify-between items-center">
                                                  <span class="flex min-w-0 w-full items-center justify-between space-x-3">
                                                    <img class="w-10 h-10 bg-gray-300 rounded-full shrink-0" :src="'/img/' + (selectedUser ? selectedUser.box_type : undefined)  + '_type_icon.png'" alt="">
                                                    <span class="flex-1 min-w-0 overflow-hidden text-ellipsis">
                                                      <span class="text-gray-900 text-sm font-medium truncate">{{ (selectedUser ? selectedUser.name : undefined) ?? 'žádná schránka' }}</span>
                                                        <br>
                                                      <span class="text-gray-500 text-sm truncate"><i>{{ (selectedUser ? selectedUser.box_id : undefined) ?? '------' }}</i></span>
                                                    </span>
                                                  </span>
                                                    <!-- Heroicon name: selector -->
                                                  <svg class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                  </svg>
                                                </span>
                                            </button>
                                        </div>


                                        <transition
                                            enter-active-class="transition ease-out duration-100"
                                            enter-from-class="transform opacity-0 scale-95"
                                            enter-to-class="transform opacity-100 scale-100"
                                            leave-active-class="transition ease-in duration-75"
                                            leave-from-class="transform opacity-100 scale-100"
                                            leave-to-class="transform opacity-0 scale-95">

                                            <div v-show="boxDropdownShow" @focusin="boxDropdownShow = true" @focusout="boxDropdownShow = false" class="z-10 mx-3 origin-top absolute right-0 left-0 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 max-h-80 overflow-auto" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                                <div v-for="user in users" class="py-1">
                                                    <button @click="selectUser(user.id)" type="button" class="group w-full px-3.5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none" aria-haspopup="true" aria-expanded="true">
                                                        <span class="flex w-full justify-between items-center">
                                                          <span class="flex min-w-0 w-full items-center justify-between space-x-3">
                                                            <img class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" :src="'/img/' + user.box_type + '_type_icon.png'" alt="">
                                                            <span class="flex-1 min-w-0 overflow-hidden text-ellipsis">
                                                              <span class="text-gray-900 text-sm font-medium truncate">{{ user.name }}</span>
                                                                <br>
                                                              <span class="text-gray-500 text-sm truncate"><i>{{ user.box_id }}</i></span>
                                                            </span>
                                                          </span>
                                                        </span>
                                                    </button>
                                                </div>

                                            </div>
                                        </transition>
                                    </div>

                                    <InertiaLink
                                        :href="route('app')"
                                        :class="activePage==='inbox' ? 'bg-gray-100' : ''"
                                        @click="activePage = 'inbox'"
                                        class="text-gray-900 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                        <svg class="text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20" />
                                        </svg>
                                        Přijaté
                                        <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                            {{ badgesCounts.inboxUnread }}
                                        </span>
                                    </InertiaLink>

                                    <InertiaLink
                                        :href="route('sent')"
                                        :class="activePage==='sent' ? 'bg-gray-100' : ''"
                                        @click="activePage = 'sent'"
                                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                        </svg>
                                        Odeslané
                                        <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                            {{ badgesCounts.sentUnread }}
                                        </span>
                                    </InertiaLink>

                                    <InertiaLink
                                        :href="route('drafts')"
                                        :class="activePage==='drafts' ? 'bg-gray-100' : ''"
                                        @click="activePage = 'drafts'"
                                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Rozepsané
                                        <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                            {{ badgesCounts.drafts }}
                                        </span>
                                    </InertiaLink>

                                    <InertiaLink
                                        :href="route('trash')"
                                        :class="activePage==='trash' ? 'bg-gray-100' : ''"
                                        @click="activePage = 'trash'"
                                        class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                        Koš
                                    </InertiaLink>

                                    <div v-if="$page.props.settings.long_term_threshold != null"
                                         class="flex items-center">
                                        <div class="flex-shrink-0 pr-4 bg-white tracking-wider text-xs font-semibold uppercase">
                                            Archiv
                                        </div>
                                        <div class="flex-1 border-t-2 border-gray-200"></div>
                                    </div>
                                    <InertiaLink
                                        v-if="$page.props.settings.long_term_threshold != null"
                                        :href="route('longterminbox')"
                                        :class="activePage==='longterminbox' ? 'bg-gray-100' : ''"
                                        @click="activePage = 'longterminbox'"
                                        class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                        <!-- Heroicon name: users -->
                                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                                        </svg>
                                        Přijaté
                                        <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.longterminbox }}
                                        </span>
                                    </InertiaLink>

                                    <InertiaLink
                                        v-if="$page.props.settings.long_term_threshold != null"
                                        :href="route('longtermsent')"
                                        :class="activePage==='longtermsent' ? 'bg-gray-100' : ''"
                                        @click="activePage = 'longtermsent'"
                                        class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                        <!-- Heroicon name: users -->
                                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                                        </svg>
                                        Odeslané
                                        <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.longtermsent }}
                                        </span>
                                    </InertiaLink>


                                </nav>
                            </div>

                            <hr class="pb-2">
                            <InertiaLink :href="route('zfo')"
                                         :class="activePage==='zfo' ? 'bg-gray-100' : ''"
                                         @click="activePage = 'zfo'"
                                         class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-4 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                Otevřít ZFO
                            </InertiaLink>
                            <hr class="pb-2 mt-2">
                            <InertiaLink :href="route('profile.show')"
                                         :class="activePage==='settings' ? 'bg-gray-100' : ''"
                                         @click="activePage = 'settings'"
                                         class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-4 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Nastavení
                            </InertiaLink>
                            <InertiaLink :href="route('help')"
                                         :class="activePage==='help' ? 'bg-gray-100' : ''"
                                         @click="activePage = 'help'"
                                         class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-4 py-2 pb-4 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Pomoc
                            </InertiaLink>

                            <div class="mx-1 my-1">
                                <div v-tooltip=" messageCount + ' z ' + messageLimit + ' zpráv'" class="overflow-hidden h-2 text-xs flex rounded bg-indigo-200">
                                    <div :style="'width: ' + ((messageCount / messageLimit) * 100) + '%'" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-500">
                                    </div>
                                </div>
                            </div>


                        </div>
                    </transition>


                    <div class="flex-shrink-0 w-14" aria-hidden="true">
                        <!-- Dummy element to force sidebar to shrink to fit close icon -->
                    </div>
                </div>
            </div>
        </transition>

        <!-- Static sidebar for desktop -->
        <div class="hidden md:flex md:flex-shrink-0">
            <div class="flex flex-col w-64">
                <div class="flex flex-col grow border-r border-gray-200 pt-3 pb-0 bg-white overflow-y-auto">
                    <div class="flex items-center flex-shrink-0 px-4">
                        <jet-nav-link class="no-underline" style="border-bottom: 0;" :href="route('app')">
                            <LogoImg full class="h-10 w-auto" />
                        </jet-nav-link>
                    </div>
                    <div class="mt-2 grow flex flex-col">
                        <nav class="flex-1 px-2 bg-white space-y-1">

                            <div class="mt-2 mb-4 relative inline-block text-left w-full">

                                <div @click="handleSelectorClick" @focusout="boxDropdownShow = false">
                                    <button type="button" class="group w-full bg-gray-100 rounded-md px-3.5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" aria-haspopup="true" aria-expanded="true">
                                        <span class="flex w-full justify-between items-center">
                                          <span class="flex min-w-0 items-center justify-between space-x-3 w-full">
                                            <img class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" :src="'/img/' + (selectedUser ? selectedUser.box_type : undefined) + '_type_icon.png'" alt="">
                                            <span class="flex-1 min-w-0 text-ellipsis overflow-hidden">
                                              <span class="text-gray-900 text-sm font-medium truncate">{{ (selectedUser ? selectedUser.name : undefined) ?? 'žádná schránka' }}</span>
                                                <br>
                                              <span class="text-gray-500 text-sm truncate"><i>{{ (selectedUser ? selectedUser.box_id : undefined) ?? '------' }}</i></span>
                                            </span>
                                          </span>
                                          <svg class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                          </svg>
                                        </span>
                                    </button>
                                </div>

                                <transition
                                    enter-active-class="transition ease-out duration-100"
                                    enter-from-class="transform opacity-0 scale-95"
                                    enter-to-class="transform opacity-100 scale-100"
                                    leave-active-class="transition ease-in duration-75"
                                    leave-from-class="transform opacity-100 scale-100"
                                    leave-to-class="transform opacity-0 scale-95">

                                    <div v-show="boxDropdownShow" @focusin="boxDropdownShow = true" @focusout="boxDropdownShow = false" class="z-10 mx-3 origin-top absolute right-0 left-0 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 max-h-80 overflow-auto" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                        <div v-for="user in users" class="py-1">
                                            <button @click="selectUser(user.id)" type="button" class="group w-full px-3.5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none" aria-haspopup="true" aria-expanded="true">
                                            <span class="flex w-full justify-between items-center">
                                              <span class="flex min-w-0 items-center justify-between space-x-3 w-full">
                                                <img class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" :src="'/img/' + user.box_type + '_type_icon.png'" alt="">
                                                <span class="flex-1 min-w-0 overflow-hidden text-ellipsis">
                                                  <span class="text-gray-900 text-sm font-medium truncate">{{ user.name }}</span>
                                                    <br>
                                                  <span class="text-gray-500 text-sm truncate">{{ user.box_id }}</span>
                                                </span>
                                              </span>
                                            </span>
                                            </button>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                            <InertiaLink
                                :href="route('app')"
                                :class="activePage==='inbox' ? 'bg-gray-100' : ''"
                                @click="activePage = 'inbox'"
                                class="relative text-gray-900 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20" />
                                </svg>
                                Přijaté
                                <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.inboxUnread }}
                                </span>
                            </InertiaLink>

                            <InertiaLink
                                :href="route('sent')"
                                :class="activePage==='sent' ? 'bg-gray-100' : ''"
                                @click="activePage = 'sent'"
                                class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                </svg>
                                Odeslané
                                <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.sentUnread }}
                                </span>
                            </InertiaLink>

                            <InertiaLink
                                :href="route('drafts')"
                                :class="activePage==='drafts' ? 'bg-gray-100' : ''"
                                @click="activePage = 'drafts'"
                                class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Rozepsané
                                <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.drafts }}
                                </span>
                            </InertiaLink>

                            <InertiaLink
                                :href="route('trash')"
                                :class="activePage==='trash' ? 'bg-gray-100' : ''"
                                @click="activePage = 'trash'"
                                class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                <svg xmlns="http://www.w3.org/2000/svg" class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                Koš
                            </InertiaLink>

                            <div v-if="$page.props.settings.long_term_threshold != null"
                                 class="flex items-center">
                                <div class="flex-shrink-0 pr-4 bg-white tracking-wider text-xs font-semibold uppercase">
                                    Archiv
                                </div>
                                <div class="flex-1 border-t-2 border-gray-200"></div>
                            </div>

                            <InertiaLink
                                v-if="$page.props.settings.long_term_threshold != null"
                                :href="route('longterminbox')"
                                :class="activePage==='longterminbox' ? 'bg-gray-100' : ''"
                                @click="activePage = 'longterminbox'"
                                class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                                </svg>
                                Přijaté
                                <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.longterminbox }}
                                </span>
                            </InertiaLink>

                            <InertiaLink
                                v-if="$page.props.settings.long_term_threshold != null"
                                :href="route('longtermsent')"
                                :class="activePage==='longtermsent' ? 'bg-gray-100' : ''"
                                @click="activePage = 'longtermsent'"
                                class="relative text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                                <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                                </svg>
                                Odeslané
                                <span class="absolute right-5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800">
                                    {{ badgesCounts.longtermsent }}
                                </span>
                            </InertiaLink>

                        </nav>
                    </div>

                    <hr class="pb-2">
                    <InertiaLink :href="route('zfo')"
                                 :class="activePage==='zfo' ? 'bg-gray-100' : ''"
                                 @click="activePage = 'zfo'"
                                 class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-4 py-2 text-sm font-medium rounded-md">
                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                        </svg>
                        Otevřít ZFO
                    </InertiaLink>
                    <hr class="pb-2 mt-2">
                    <InertiaLink :href="route('profile.show')"
                                 :class="activePage==='settings' ? 'bg-gray-100' : ''"
                                 @click="activePage = 'settings'"
                                 class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-4 py-2 text-sm font-medium rounded-md">
                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        Nastavení
                    </InertiaLink>
                    <InertiaLink :href="route('help')"
                                 :class="activePage==='help' ? 'bg-gray-100' : ''"
                                 @click="activePage = 'help'"
                                 class="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-4 py-2 pb-4 text-sm font-medium rounded-md">
                        <svg class="text-gray-500 group-hover:text-gray-500 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Pomoc
                    </InertiaLink>

                    <div class="mx-1 my-1">
                        <div v-tooltip=" messageCount + ' z ' + messageLimit + ' zpráv'" class="overflow-hidden h-2 text-xs flex rounded bg-indigo-200">
                            <div :style="'width: ' + ((messageCount / messageLimit) * 100) + '%'" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-500">
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
            <div class="relative z-10 flex-shrink-0 flex h-10 bg-white shadow">
                <button @click="showMainMenu = true" class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden">
                    <span class="sr-only">Otevřít postranní menu</span>
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
                    </svg>
                </button>
                <div class="flex-1 px-4 flex justify-between">
                    <div class="flex-1 flex">
                        <form v-if="activePage === 'inbox' || activePage === 'sent'  || activePage === 'longterminbox' || activePage === 'longtermsent'" @submit.prevent="getSearch" id="search-form" class="w-full flex md:ml-0" action="#" method="GET">
                            <label for="search_field" class="sr-only">Vyhledávání</label>
                            <div class="relative w-full text-gray-400 focus-within:text-gray-600">
                                <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                                    </svg>
                                </div>
                                <input v-model="search" autocomplete="off" id="search_field" class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm"
                                       :placeholder="'Vyhledávání'" type="search" name="search">
                            </div>
                        </form>
                    </div>
                    <div class="ml-4 flex items-center md:ml-6">

                        <a @click="resolveISDSIssue" v-tooltip="'Tato schránka není připojena k ISDS. Kliknutím přistupte k vyřešení.'" v-if="(selectedUser ? selectedUser.id : undefined) in $page.props.isdserror" :href="'#'">
                            <button class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none">
                                <span class="sr-only">Chyba připojení ISDS</span>
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="red">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
                                </svg>
                            </button>
                        </a>
                        <a v-if="$page.props.su" :href="'/app/admin/nova'">
                            <button class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none">
                                <span class="sr-only">Nova</span>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                                </svg>
                            </button>
                        </a>
                        <a v-if="$page.props.su && route().check('telescope')" :href="route('telescope')">
                            <button class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none">
                                <span class="sr-only">Telescope</span>
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
                                </svg>
                            </button>
                        </a>
                        <a v-if="$page.props.su" :href="route('horizon.index')">
                            <button class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none">
                                <span class="sr-only">Horizon</span>
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                                </svg>
                            </button>
                        </a>

                        <button v-if="last_alerts.length > 0" class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none">
                            <span class="sr-only">Zobrazit upozornění</span>
                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                            </svg>
                        </button>


                        <!-- Profile dropdown -->
                        <div class="ml-3 relative">
                            <div>
                                <button
                                    v-if="$page.props.jetstream.managesProfilePhotos"
                                    @click="showUserMenu = !showUserMenu"
                                    @focusout="showUserMenu = false"
                                    class="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" id="user-menu" aria-haspopup="true">
                                    <span class="sr-only">Open user menu</span>
                                    <img class="h-8 w-8 rounded-full object-cover" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" />
                                </button>

                                <button
                                    v-else
                                    @click="showUserMenu = !showUserMenu"
                                    @focusout="showUserMenu = false"
                                    class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
                                    <div>{{ $page.props.user.name }}</div>
                                    <div class="ml-1">
                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </button>
                            </div>

                            <transition
                                enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95"
                            >
                                <div
                                    @focusin="showUserMenu = true"
                                    @focusout="showUserMenu = false"
                                    v-show="showUserMenu"
                                    class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">

                                    <!-- Account Management -->
                                    <div class="block px-4 py-2 text-xs text-gray-400">
                                        Správa účtu
                                    </div>

                                    <jet-dropdown-link :href="route('profile.show')">
                                        Profil
                                    </jet-dropdown-link>

                                    <jet-dropdown-link :href="route('api-tokens.index')" v-if="$page.props.jetstream.hasApiFeatures">
                                        API Přístupy
                                    </jet-dropdown-link>

                                    <div v-if="$page.props.user.partner" class="border-t border-gray-100"></div>

                                    <jet-dropdown-link v-if="$page.props.user.partner" :href="route('partner')">
                                        Partnerský portál
                                    </jet-dropdown-link>

                                    <div class="border-t border-gray-100"></div>

                                    <!-- Team Management -->
                                    <template v-if="$page.props.jetstream.hasTeamFeatures">
                                        <div class="block px-4 py-2 text-xs text-gray-400">
                                            Správa týmů
                                        </div>

                                        <!-- Team Settings -->
                                        <jet-dropdown-link :href="route('teams.show', $page.props.user.current_team)">
                                            Nastavení týmu
                                        </jet-dropdown-link>

                                        <jet-dropdown-link :href="route('teams.create')" v-if="$page.props.jetstream.canCreateTeams">
                                            Vytvořit nový tým
                                        </jet-dropdown-link>

                                        <div class="border-t border-gray-100"></div>

                                        <!-- Team Switcher -->
                                        <div class="block px-4 py-2 text-xs text-gray-400">
                                            Přepnout tým
                                        </div>

                                        <template v-for="team in $page.props.user.all_teams" :key="team.id">
                                            <form @submit.prevent="switchToTeam(team)">
                                                <jet-dropdown-link as="button">
                                                    <div class="flex items-center">
                                                        <svg v-if="team.id === $page.props.user.current_team_id" class="mr-2 h-5 w-5 text-green-400" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                                        <div>{{ team.name }}</div>
                                                    </div>
                                                </jet-dropdown-link>
                                            </form>
                                        </template>

                                        <div class="border-t border-gray-100"></div>
                                    </template>

                                    <!-- Authentication -->
                                    <form @submit.prevent="logout">
                                        <jet-dropdown-link as="button">
                                            Odhlásit
                                        </jet-dropdown-link>
                                    </form>

                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

            <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
                <slot></slot>
                <p>&nbsp;</p>
            </main>


            <InertiaLink v-if="activePage === 'inbox' || activePage === 'longterminbox' || activePage === 'sent' || activePage === 'longtermsent' || activePage === 'drafts' || activePage === 'trash'" :href="route('compose')" class="fixed bottom-4 right-4">

                <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <!-- Heroicon name: solid/mail -->
                    <svg class="-ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    Nová zpráva
                </button>
            </InertiaLink>

            <dialog-modal :show="shouldWelcome && users.length === 0">
                <template #icon>
                    <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white sm:mx-0 sm:h-10 sm:w-10">
                        <!-- Heroicon name: exclamation -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                    </div>
                </template>
                <template #title>Vítejte!</template>
                <template #content>
                    Jsme rádi, že jste si vybrali DSchránku a vítáme Vás v aplikaci!
                    Poslední, co Vám zbývá, je připojit svou datovou schránku.
                    <br>
                    <br>
                    Nemáte ještě datovou schránku? Podívejte se <a href="https://www.datoveschranky.info/chci-datovku/zrizeni-datove-schranky" target="_blank" class="underline">sem</a>, jak na to.
                </template>
                <template #footer>
                    <jet-button @click.native="dismissWelcomeToSettings" class="ml-2">
                        Připojit schránku
                    </jet-button>
                </template>
            </dialog-modal>
            <dialog-modal :show="settings.initial_import == null && users.length > 0">
                <template #icon>
                    <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                        <!-- Heroicon name: exclamation -->
                        <svg class="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </div>
                </template>
                <template #title>Úvodní import</template>
                <template #content>Přejete si stáhnout dostupnou historii vašich zpráv (zprávy odeslané nebo přijaté v minulosti)? <i>Všechny takové zprávy budou označeny jako přečtené.</i> </template>
                <template #footer>
                    <jet-button :class="{ 'opacity-25': settingsSubmitProcessing }" :disabled="settingsSubmitProcessing" @click.native="saveSetting('initial_import', 1)" class="ml-2">
                        Ano
                    </jet-button>
                    <secondary-button :class="{ 'opacity-25': settingsSubmitProcessing }" :disabled="settingsSubmitProcessing" @click.native="saveSetting('initial_import', 0)">
                        Ne
                    </secondary-button>

                </template>
            </dialog-modal>
            <dialog-modal :show="settings.automatic_delivery == null && settings.initial_import != null && users.length > 0">
                <template #icon>
                    <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                        <!-- Heroicon name: exclamation -->
                        <svg class="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </div>
                </template>
                <template #title>Automatické doručování</template>
                <template #content>Přejete si automaticky stahovat nové zprávy, zatímco jste přihlášen/a a pracujete v DSchránce?</template>
                <template #footer>
                    <jet-button :class="{ 'opacity-25': settingsSubmitProcessing }" :disabled="settingsSubmitProcessing" @click.native="saveSetting('automatic_delivery', 1)" class="ml-2">
                        Ano
                    </jet-button>
                    <secondary-button :class="{ 'opacity-25': settingsSubmitProcessing }" :disabled="settingsSubmitProcessing" @click.native="saveSetting('automatic_delivery', 0)">
                        Ne
                    </secondary-button>
                </template>
            </dialog-modal>
            <dialog-modal :working="mkAuthorizationProcessing" :show="mkAuthorizationRequired">
                <template #icon>
                    <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                        <!-- Heroicon name: exclamation -->
                        <svg class="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </div>
                </template>
                <template #title>Autorizace Mobilním Klíčem</template>
                <template #content>
                    <div v-if="mkAuthorizationStep === 0"> Některé akce, které se DSchránka pokouší vykonat na vybraném účtu vyžadují autorizaci Mobilním Klíčem eGovernmentu. Přejete si nyní provést ověření?  </div>
                    <div v-if="mkAuthorizationStep === 1"> Probíhá ověřování </div>
                    <div v-if="mkAuthorizationStep === 2"> Potvrďte připojení do Vaší datové schránky v aplikaci Mobilní klíč eGovermentu.  </div>
                    <div v-if="mkAuthorizationStep === 3"> Ověření proběhlo úspěšně! Čekejte, prosím. </div>

                </template>
                <template #footer>
                    <jet-button v-if="mkAuthorizationStep === 0" :class="{ 'opacity-25': mkAuthorizationProcessing }" :disabled="mkAuthorizationProcessing" @click.native="startMKAuthorization" class="ml-2">
                        Autorizovat
                    </jet-button>
                    <secondary-button v-if="mkAuthorizationStep === 0" :class="{ 'opacity-25': mkAuthorizationProcessing }" :disabled="mkAuthorizationProcessing" @click.native="abortMKAuth(false)">
                        Pokračovat bez autorizace
                    </secondary-button>
                    <secondary-button v-if="mkAuthorizationStep !== 0" @click.native="abortMKAuth(false)">
                        Zrušit
                    </secondary-button>

                </template>
            </dialog-modal>

        </div>
    </div>

</template>

<script>
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
import Button from "@/Jetstream/Button";
import ConfirmationModal from "@/Jetstream/ConfirmationModal";
import DialogModal from "@/Jetstream/DialogModal";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import { Link, Head } from '@inertiajs/inertia-vue3'
import { useToast } from "vue-toastification";
import LogoImg from "../Components/LogoImg";

export default {
    props: {
        title: String,
    },
    components: {
        LogoImg,
        SecondaryButton,
        DialogModal,
        ConfirmationModal,
        'jet-button': Button,
        JetApplicationMark,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
        InertiaLink: Link,
        Head,
    },

    data() {
        return {
            showingNavigationDropdown: false,
            showUserMenu: false,
            showMainMenu: false,
            activePage: this.$page.props.activePage,
            boxDropdownShow: false,
            users: this.$page.props.users,
            selectedUser: this.$page.props.selectedUser,
            search: this.$page.props.search,

            settings: this.$page.props.selectedUser?.settings ?? {},
            settingsSubmitProcessing: false,

            alerts: this.$page.props.alerts ?? [],
            last_alerts: this.$page.props.last_alerts,

            badgesCounts: this.$page.props.badgesCounts,

            messageLimit: this.$page.props.messageLimit ? this.$page.props.messageLimit : 0,
            messageCount: this.$page.props.messageCount,

            isOnTrial: this.$page.props.isOnTrial,

            mkAccountExcluded: this.$page.props.selectedMKAccountExcluded,
            mkAuthorizationRequired: this.$page.props.selectedMKAccountNeedsAuthorization,
            mkAuthorizationStep: 0,
            mkAuthorizationProcessing: false,
            mkAuthorizationSCookie: null,
            mkAuthorizationInterval: null,

            shouldWelcome: localStorage.getItem('shouldWelcome') === '1',

            echoRunning: false,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    updated() {
        this.activePage = this.$page.props.activePage;
        this.users = this.$page.props.users;
        this.selectedUser = this.$page.props.selectedUser;
    },
    mounted(){
        console.log('%cToto je vývojářská konzole. Pro vlastní bezpečí nikdy nevkládejte cizí kód/text, pokud si nejste jisti, k čemu tento nástroj slouží a jak se s ním pracuje. -Vaše DSchránka', 'color: red; font-weight: bold; font-size: large;')
        this.showAlerts();

        this.setUpEcho();

        this.reportConversion();
    },
    unmounted(){
        this.destroyEcho();
    },

    methods: {
        dismissWelcomeToSettings(){
            localStorage.removeItem('shouldWelcome');
            this.$inertia.get(route('settings.isds'));
        },
        handleSelectorClick(){
            if(this.users.length === 0) this.$inertia.get(route('settings.isds'));
            else this.boxDropdownShow = !this.boxDropdownShow;
        },
        reportConversion(){
            if(!localStorage.getItem('reportConversion')) return;
            gtag('event', 'registered', { event_label: 'registered', value: true });
            localStorage.removeItem('reportConversion');
        },
        setUpEcho(){
            console.log('setup up echo layout')
            Echo.private('App.Models.User.' + this.$page.props.user.id)
                .listen('TestEvent', (e) => {
                    console.log(e);
                })
                .listen('MessagesChanged', (e) => {
                    console.log('MessagesChanged', e);
                    this.refreshBadges();
                })
                .listen('AlertCreated', (e) => {
                    console.log('AlertCreated', e);
                    this.refreshAlerts();
                });
        },
        destroyEcho(){
            console.log('destroy echo layout')
            Echo.leave('App.Models.User.'+this.$page.props.user.id);
        },
        resolveISDSIssue(){
            if(this.selectedUser.method === 4) {
                this.mkAuthorizationRequired = true
            } else {
                this.$inertia.get(route('settings.progress.ISDSError', {user_id: this.selectedUser.id}));
            }
        },
        startMKAuthorization(){
            this.mkAuthorizationProcessing = true;
            this.mkAuthorizationStep++;
            axios.post(route('fapi.isds.mk'), {isdsuser_id: this.selectedUser.id, step: 1})
                .then( (response) => {
                    this.mkAuthorizationSCookie = response.data.sCookie;
                    this.mkAuthorizationStep++;
                    this.mkAuthorizationInterval = setInterval(this.checkMKAccepted, 5000);
                } )
                .catch( (error) => {
                    this.toast.warning('Nebylo možné ověřit tento účet!');
                    this.abortMKAuth(false);
                } );
        },
        checkMKAccepted(){
            axios.post(route('fapi.isds.mk'), {sCookie: this.mkAuthorizationSCookie, step: this.mkAuthorizationStep})
                .then( (response) => {
                    if(response.data.status === 2){
                        this.finalizeMKAuth();
                    }
                    else if(response.data.status === -1 || response.data.status === 3) {
                        this.toast.warning('Požadavek byl odmítnut nebo vypršel. Zkuste to znovu!');
                        this.abortMKAuth(false);
                    }
                })
                .catch( (error) => {
                    this.toast.warning('Stala se neočekávaná chyba!');
                    this.abortMKAuth(false);
                } );
        },
        finalizeMKAuth(){
            this.mkAuthorizationStep++;
            clearInterval(this.mkAuthorizationInterval);
            axios.post(route('fapi.isds.mk'), {
                isdsuser_id: this.selectedUser.id,
                sCookie: this.mkAuthorizationSCookie,
                step: 3,
            })
                .then( (response) => {
                    this.mkAuthorizationProcessing = false;
                    setTimeout( () => {
                            this.abortMKAuth(true);
                            this.$inertia.reload({preserveState: false});
                        }, 2000);
                })
                .catch( (error) => {
                    this.toast.warning('Stala se neočekávaná chyba!');
                    this.abortMKAuth(false);
                });
        },
        abortMKAuth(authorized){
            if(this.mkAuthorizationInterval) clearInterval(this.mkAuthorizationInterval);
            this.mkAuthorizationRequired = false;
            this.mkAuthorizationStep = 0;
            this.mkAuthorizationSCookie = null;
            this.mkAuthorizationProcessing = false;
            if(authorized === false) this.dontAuthorizeMK();
        },


        dontAuthorizeMK(){
            axios.post(route('fapi.isds.mk'), {isdsuser_id: this.selectedUser.id, step: -1})
                .then( (response) => {
                    this.toast.info('Datová schránka nebude připojena do ISDS!');
                })
                .catch( (error) => {
                    this.toast.warning('Stala se neočekávaná chyba!');
                } );
        },


        getSearch(){
            this.$inertia.get('#', {search: this.search})
        },
        switchToTeam(team) {
            this.$inertia.put(route('current-team.update'), {team_id: team.id}, {
                preserveState: false
            });
        },

        logout() {
            axios.post(route('logout')).then(response => {
                window.location = route('index');
            });
        },

        selectUser(id){
            this.$inertia.visit(route('settings.selectUser'), {
                method: 'post',
                data: {selected: id}
            });
        },

        saveSetting(setting, value){
            this.settingsSubmitProcessing = true;

            let request;
            if(setting === 'automatic_delivery') request = {settings: {automatic_delivery: value}, referer: 'initial'};
            if(setting === 'initial_import') request = {settings: {initial_import: value}, referer: 'initial'};

            axios.post(route('settings.isds.settings'), request)
                .then(response => {
                    if(response.status === 200){
                        if(setting === 'automatic_delivery'){
                            this.settings.automatic_delivery = value;
                        }
                        if(setting === 'initial_import'){
                            this.settings.initial_import = value;
                        }
                    }
                    this.settingsSubmitProcessing = false;
                })
                .catch(error => {
                    this.toast.warning('Něco se pokazilo. Zkuste to později.');
                });
        },

        showAlerts(){
            for(let i = 0; i < this.alerts.length; i++){

                if(this.alerts[i].type === 1) this.toast.success(this.alerts[i].text);
                if(this.alerts[i].type === 2) this.toast.warning(this.alerts[i].text);
                if(this.alerts[i].type === 3) this.toast.info(this.alerts[i].text);
            }
        },
        refreshAlerts(){
            axios.get(route('fapi.getalerts'))
                .then(response => {
                    if(response.status === 200) {
                        this.alerts = response.data.alerts;
                        this.showAlerts();
                    }
                });
        },
        refreshBadges(){
            axios.get(route('fapi.getbadges'))
                .then(response => {
                    if(response.status === 200) {
                        this.badgesCounts = response.data.badgesCounts;
                    }
                });
        },

    },
    watch: {
        alerts(oldAlerts, newAlerts){
            console.log(newAlerts);
        }
    }
}
</script>
